import EscapeManager from '../../../js/Managers/EscapeManager.js';

class SiteModal extends HTMLElement {
  autoOpen = false;
  dialog = null;
  buttons = null;
  iframes = null;
  videos = null;

  cookieID = false;
  cookieLength = 24 * 60 * 60; // Default to 24 hours

  escapeManagerID = `siteModal` + Math.random().toString(36).substring(2, 15);

  constructor() {
    super();

    this.autoOpen = this.hasAttribute('data-autoopen') || false;
    this.dialog = this.querySelector('.site-modal__dialog');
    this.buttons = this.querySelectorAll('[data-modal-opener], [data-modal-closer]');
    this.iframes = this.querySelectorAll('iframe');
    this.videos = this.querySelectorAll('video');

    this.cookieID = this.getAttribute('data-cookie-id') || false;
    this.cookieLength = this.getAttribute('data-cookie-length') || 24 * 60 * 60;

    if (this.autoOpen) {
      if (this.cookieID) {
        // Check if cookie is set
        const cookieValue = document.cookie
          .split('; ')
          .find(row => row.startsWith(this.cookieID))
          ?.split('=')[1];

        if (!cookieValue) {
          this.open = true;
        }
      } else {
        // If no cookie ID is set, open the modal
        this.open = true;
      }
    }

    this._onButtonClick = this.onButtonClick.bind(this);
    this._onModalOpen = this.onModalOpen.bind(this);
    this._onModalClose = this.onModalClose.bind(this);
    this._onDialogClick = this.onDialogClick.bind(this);
  }

  connectedCallback() {
    this.addEventListeners();
  }
  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.buttons.forEach($el => {
      $el.addEventListener('click', this._onButtonClick);
    });

    this.dialog.addEventListener('open', this._onModalOpen);
    this.dialog.addEventListener('close', this._onModalClose);

    // Close modal when clicking dialog backdrop
    this.dialog.addEventListener('click', this._onDialogClick);
  }

  removeEventListeners() {
    this.buttons.forEach($el => {
      $el.removeEventListener('click', this._onButtonClick);
    });

    this.dialog.removeEventListener('open', this._onModalOpen);
    this.dialog.removeEventListener('close', this._onModalClose);

    // Close modal when clicking dialog backdrop
    this.dialog.removeEventListener('click', this._onDialogClick);
  }

  onButtonClick() {
    this.toggle();
  }

  get open() {
    return this.dialog.open;
  }

  set open(value) {
    if (value) {
      this.dialog.showModal();
      // Event hack to trigger onModalOpen
      this.dialog.dispatchEvent(new Event('open'));
      EscapeManager.add(this.escapeManagerID, () => {
        this.open = false;
      });
    } else {
      this.dialog.close();
      EscapeManager.remove(this.escapeManagerID);
    }
  }

  toggle() {
    this.open = !this.open;
  }

  onModalOpen() {
    this.iframes.forEach(iframe => {
      if (iframe.getAttribute('data-src')) {
        iframe.src = iframe.getAttribute('data-src');
        iframe.removeAttribute('data-src');
      }
    });
  }

  onModalClose() {
    // Pause all videos
    this.videos.forEach(video => {
      video.pause();
    });

    // Pause all youtube videos
    this.iframes.forEach(iframe => {
      const src = iframe.src;

      if (iframe.hasAttribute('data-youtube')) {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
          '*',
        );
      } else {
        iframe.setAttribute('data-src', src);
        iframe.src = '';
      }
    });

    // Set cookie to prevent auto-open
    if (this.cookieID) {
      const date = new Date();
      date.setTime(date.getTime() + this.cookieLength * 1000);
      document.cookie = `${this.cookieID}=true; expires=${date.toUTCString()}; path=/`;
    }
  }

  onDialogClick(event) {
    if (event.target === this.dialog) {
      this.open = false;
    }
  }
}

customElements.define('site-modal', SiteModal);
